var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _ellipse, _path, _circle2, _path2, _path3, _rect10, _circle3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkWebAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 143,
    viewBox: "0 0 171 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.2414,
    cy: 65.759,
    r: 65.759,
    fill: "#E6F6FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1110_7950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 31,
    width: 118.15,
    height: 70.3271,
    rx: 2.81308,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.3662,
    y: 41.6565,
    width: 25.5735,
    height: 28.415,
    rx: 1.68785,
    fill: "#E6F6FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6973,
    y: 41.6897,
    width: 62.4505,
    height: 2.81308,
    rx: 1.40654,
    fill: "#00A6CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6973,
    y: 49.0038,
    width: 45.572,
    height: 2.81308,
    rx: 1.40654,
    fill: "#00A6CA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6973,
    y: 60.8187,
    width: 19.6916,
    height: 2.81308,
    rx: 1.40654,
    fill: "#00A6CA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.2021,
    y: 60.8363,
    width: 17.049,
    height: 2.8415,
    rx: 1.42075,
    fill: "#00A6CA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.093,
    y: 60.8363,
    width: 17.049,
    height: 2.8415,
    rx: 1.42075,
    fill: "#00A6CA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.252,
    y: 79.3851,
    width: 46.1346,
    height: 2.81308,
    rx: 1.40654,
    fill: "#00A6CA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76.7012,
    y: 79.3851,
    width: 41.071,
    height: 2.81308,
    rx: 1.40654,
    fill: "#00A6CA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 23.252,
    y: 86.6991,
    width: 100.146,
    height: 2.81308,
    rx: 1.40654,
    fill: "#00A6CA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1921,
    cy: 53.5047,
    rx: 7.87664,
    ry: 9.00187,
    fill: "#99DBEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3196 69.8206C46.3196 69.8206 41.7856 69.8206 36.1925 69.8206C30.5995 69.8206 26.0654 69.8206 26.0654 69.8206C26.0654 68.2669 30.5995 64.1944 36.1925 64.1944C41.7856 64.1944 46.3196 68.2669 46.3196 69.8206Z",
    fill: "#99DBEA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.649,
    cy: 77.4989,
    r: 29.4617,
    transform: "rotate(-45 105.649 77.4989)",
    fill: "white",
    stroke: "#005F8D",
    strokeWidth: 2.42151
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.056 60.0909C125.343 62.3769 127.156 65.0909 128.393 68.0777C129.63 71.0646 130.267 74.2659 130.267 77.4989C130.267 80.7319 129.63 83.9332 128.393 86.9201C127.156 89.907 125.343 92.6209 123.056 94.907",
    stroke: "#005F8D",
    strokeWidth: 1.61434,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.338 103.754L131.904 99.1877L149.312 116.596C150.573 117.857 150.573 119.901 149.312 121.162C148.051 122.423 146.007 122.423 144.746 121.162L127.338 103.754Z",
    fill: "#005F8D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 123.913,
    y: 100.329,
    width: 6.45736,
    height: 3.63227,
    transform: "rotate(-45 123.913 100.329)",
    fill: "#005F8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1110_7950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 49,
    width: 57,
    height: 57
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.655,
    cy: 77.4985,
    r: 28.251,
    transform: "rotate(-45 105.655 77.4985)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1110_7950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.114 89.8159C113.006 89.8159 113.729 89.0931 113.729 88.2016C113.729 87.31 113.006 86.5872 112.114 86.5872V89.8159ZM78.415 89.8159H112.114V86.5872H78.415V89.8159Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.755 78.919C117.647 78.919 118.37 78.1962 118.37 77.3046C118.37 76.4131 117.647 75.6903 116.755 75.6903V78.919ZM79.39 78.919C80.2816 78.919 81.0043 78.1962 81.0043 77.3046C81.0043 76.4131 80.2816 75.6903 79.39 75.6903V78.919ZM86.1837 75.6903C85.2921 75.6903 84.5694 76.4131 84.5694 77.3046C84.5694 78.1962 85.2921 78.919 86.1837 78.919V75.6903ZM92.9774 78.919C93.869 78.919 94.5917 78.1962 94.5917 77.3046C94.5917 76.4131 93.869 75.6903 92.9774 75.6903V78.919ZM99.7711 75.6903C98.8795 75.6903 98.1567 76.4131 98.1567 77.3046C98.1567 78.1962 98.8795 78.919 99.7711 78.919V75.6903ZM106.565 78.919C107.456 78.919 108.179 78.1962 108.179 77.3046C108.179 76.4131 107.456 75.6903 106.565 75.6903V78.919ZM113.358 75.6903C112.467 75.6903 111.744 76.4131 111.744 77.3046C111.744 78.1962 112.467 78.919 113.358 78.919V75.6903ZM75.9932 78.919H79.39V75.6903H75.9932V78.919ZM86.1837 78.919H92.9774V75.6903H86.1837V78.919ZM99.7711 78.919H106.565V75.6903H99.7711V78.919ZM113.358 78.919H116.755V75.6903H113.358V78.919Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.114 68.4258C113.006 68.4258 113.729 67.703 113.729 66.8114C113.729 65.9199 113.006 65.1971 112.114 65.1971V68.4258ZM78.415 68.4258H112.114V65.1971H78.415V68.4258Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.544 57.529C116.436 57.529 117.159 56.8062 117.159 55.9146C117.159 55.0231 116.436 54.3003 115.544 54.3003V57.529ZM84.6699 57.529H115.544V54.3003H84.6699V57.529Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.948 101.116C116.839 101.116 117.562 100.393 117.562 99.5019C117.562 98.6103 116.839 97.8876 115.948 97.8876V101.116ZM85.2754 101.116H115.948V97.8876H85.2754V101.116Z",
    fill: "#00A6CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1110_7950",
    x: 0.747662,
    y: 19.7477,
    width: 140.654,
    height: 92.8318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.62617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1110_7950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1110_7950",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkWebAlert);
export default __webpack_public_path__ + "static/media/dark-web-alert.8378d39a7f7ad606744708dc4a6819d9.svg";
export { ForwardRef as ReactComponent };